var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-card", { staticClass: "px-6 py-6", attrs: { flat: "" } }, [
        _c(
          "div",
          { staticClass: "d-flex align-center mb-4" },
          [
            _c("h1", [_vm._v("All Projects")]),
            _c("v-spacer"),
            _c(
              "v-btn",
              {
                staticClass: "mr-3",
                attrs: {
                  small: "",
                  outlined: "",
                  color: "primary",
                  to: `/pages/research/client/${_vm.$route.params.clientId}`,
                },
              },
              [
                _c("v-icon", { attrs: { left: "", small: "" } }, [
                  _vm._v("mdi-arrow-left"),
                ]),
                _vm._v(" Back to Client Info "),
              ],
              1
            ),
            _c(
              "a",
              {
                staticClass: "ml-2",
                attrs: {
                  href: `/#/pages/research/client/${_vm.$route.params.clientId}/new-project`,
                },
              },
              [
                _c(
                  "v-btn",
                  { attrs: { small: "", color: "primary", outlined: "" } },
                  [
                    _c("v-icon", { attrs: { left: "", small: "" } }, [
                      _vm._v("mdi-plus-box-outline"),
                    ]),
                    _vm._v(" Create New "),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "text-center py-8" },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", color: "primary" },
                }),
                _c("div", { staticClass: "mt-4" }, [
                  _vm._v("Loading projects..."),
                ]),
              ],
              1
            )
          : _vm.sortedProjects.length === 0
          ? _c(
              "div",
              { staticClass: "text-center py-8" },
              [
                _c(
                  "v-icon",
                  { attrs: { size: "64", color: "grey lighten-1" } },
                  [_vm._v("mdi-folder-open")]
                ),
                _c("div", { staticClass: "mt-4 text-h6 grey--text" }, [
                  _vm._v("No projects found"),
                ]),
                _c("div", { staticClass: "text-body-2 grey--text" }, [
                  _vm._v(" Create your first project to get started "),
                ]),
              ],
              1
            )
          : _c(
              "div",
              _vm._l(_vm.sortedProjects, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "project-module mb-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center px-4 py-3" },
                      [
                        _c("div", { staticClass: "flex-grow-1" }, [
                          _c(
                            "div",
                            { staticClass: "font-weight-bold text-h6 mb-1" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "project-link",
                                  attrs: {
                                    href: `#/pages/projects/${item.id}/clusters`,
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.name) + " ")]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "text-body-2 mb-2" }, [
                            _vm._v(
                              " " + _vm._s(item.description || "N/A") + " "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "mb-1" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "grey--text text--darken-1 mr-3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.project_type || "No type") +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  class: {
                                    flat:
                                      !_vm.isFailStatus(item) &&
                                      !_vm.isSuccessStatus(item),
                                    red: _vm.isFailStatus(item),
                                    green: _vm.isSuccessStatus(item),
                                  },
                                  attrs: { small: "", label: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "text-white": _vm.isFailStatus(item),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.status || "N/A") + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "text-caption grey--text" },
                            [
                              _vm._v(
                                " Last modified: " +
                                  _vm._s(_vm.formatDate(item.updated_at)) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }